// JOBE-0166.2: MetricRow — single metric row in an expanded suite card section.
// JOBE-0166.3: Wires <StatusPill>.
// JOBE-0166.4: Wires <Spark mode="absolute" target={...}> and latency callout.

import { formatMetricValue } from './metricFormat.js';
import { metricStatus } from './metricStatus.js';
import { StatusPill } from '../components/StatusPill/StatusPill.jsx';
import { Spark } from '../components/Spark/Spark.jsx';
import './MetricRow.css';

/**
 * Derive a Spark tone from the metric's status tone.
 * The Spark tone controls the data series line color.
 * ok → 'ok', warn → 'warn', bad → 'bad', pencil → 'ink' (no data).
 */
function sparkTone(statusTone) {
  if (statusTone === 'ok') return 'ok';
  if (statusTone === 'warn') return 'warn';
  if (statusTone === 'bad') return 'bad';
  return 'ink';
}

/**
 * @param {object} props
 * @param {import('./mock-suites.js').Metric} props.metric
 */
export function MetricRow({ metric }) {
  const { label, description, current, target, unit, section, history } = metric;
  const { tone, label: pillLabel } = metricStatus(metric);

  return (
    <>
      <div className="metric-row" data-section={section}>
        <div className="metric-label-col">
          <span className="metric-label">{label}</span>
          <span className="metric-desc">{description}</span>
        </div>
        <div className="metric-value-col">
          {current !== null && current !== undefined
            ? <span className="metric-value">{formatMetricValue(current, unit)}</span>
            : <span className="metric-value muted">—</span>}
        </div>
        <div className="metric-target-col">
          <span className="metric-target">{formatMetricValue(target, unit)}</span>
        </div>
        <div className="metric-spark-col">
          {history && history.length > 0
            ? <Spark
                mode="absolute"
                data={history}
                target={target}
                tone={sparkTone(tone)}
                unit={unit === 'ratio' ? '%' : unit === 'ms' ? 'ms' : ''}
                ariaLabel={`${label} trend`}
              />
            : <span className="metric-spark-empty" aria-label="No history" />}
        </div>
        <div className="metric-pill-col">
          <StatusPill tone={tone} label={pillLabel} />
        </div>
      </div>
      {metric.id === 'latency_token_cost' && (
        <div className="metric-callout" role="note" data-testid="metric-callout">
          <span className="metric-callout-caret">▸</span>
          <span className="metric-callout-text">
            harness needs parallel shards — 122 k ms reflects serial
            episode scanning; blocked on JOBE-0076-followup
          </span>
        </div>
      )}
    </>
  );
}
